import {ValidationMessage} from '../../models/ValidationMessage';
import {LENGTH_LIMIT_URL_QUERY_PARAMETER, SEARCH_TERM_MINIMAL_CHARACTERS_LENGTH} from '../../init/constants';
import {ValidationMessageType} from '../../models/ValidationMessageType';
import {t} from 'i18next';
import {setErrorDescription} from './ErrorDialogue';

export const getErrorDataValidationMessages = (headline: string | undefined, validationMessages: ValidationMessage[]): Partial<{ headline?: string, errorDescription?: string }> => {
    let errorData = {
        headline: headline ?? t('GENERAL_ERROR_HEADER'),
        errorDescription: setErrorDescription(validationMessages ?? [])
    } as Partial<{ headline?: string, errorDescription?: string }>;

    return errorData;
}

export const getUrlLengthLimitConstraintErrorMessage = (urlLength: number): ValidationMessage[] => {
    let validationMessages: ValidationMessage[] = [];
    validationMessages.push({
        key: 'URL length have exceeded the maximum length of {{param1}}. Actual size: {{param2}}. Hint: Lower the number of used search parameters.',
        keyCode: 'ERROR_LENGTH_LIMIT_URL_QUERY_PARAMETER_CONSTRAINT',
        params: [LENGTH_LIMIT_URL_QUERY_PARAMETER as unknown as object,
            urlLength as unknown as object],
        type: ValidationMessageType.ERROR
    } as ValidationMessage);

    return validationMessages;
}

export const getGeneralErrorErrorMessage = (): ValidationMessage[] => {
    let validationMessages: ValidationMessage[] = [];
    validationMessages.push({
        key: 'General error have occurred.',
        keyCode: 'HINT_GENERAL_ERROR',
        params: [],
        type: ValidationMessageType.INFO
    } as ValidationMessage);

    return validationMessages;
}

export const getNoDataFoundErrorMessage = (): ValidationMessage[] => {
    let validationMessages: ValidationMessage[] = [];
    validationMessages.push({
        key: 'There are no entries available.',
        keyCode: 'HINT_NO_ITEMS',
        params: [],
        type: ValidationMessageType.INFO
    } as ValidationMessage);

    return validationMessages;
}

export const getDownloadServiceNotEnabledErrorMessage = (): ValidationMessage[] => {
    let validationMessages: ValidationMessage[] = [];
    validationMessages.push({
        key: 'Looks like the Download Service is disabled. Please take a look into the corresponding \'DXF Configuration (GCA)\' section in FirstSpirit.',
        keyCode: 'HINT_DLS_DISABLED',
        params: [],
        type: ValidationMessageType.INFO
    } as ValidationMessage);

    return validationMessages;
}

export const getSearchTermConstraintErrorMessage = (): ValidationMessage[] => {
    let validationMessages: ValidationMessage[] = [];
    validationMessages.push({
        key: `Search parameter must be at least ${SEARCH_TERM_MINIMAL_CHARACTERS_LENGTH} charters long and must contain no leading and trailing empty spaces`,
        keyCode: 'ERROR_SEARCH_PARAMETER_VALUE_CONSTRAINT',
        params: [new Object(SEARCH_TERM_MINIMAL_CHARACTERS_LENGTH)],
        type: ValidationMessageType.INFO
    } as ValidationMessage);

    return validationMessages;
}